import { OperatorConfig } from "..";

// PROD
const sourcesConfig: OperatorConfig = {
  backoffice: {
    display: {
      "sidebar.menu.management.incidents": false,
      "sidebar.menu.management.visits": false,
      "sidebar.menu.communicate": false,
      // quotes
      "sidebar.menu.quote": true,
      "sidebar.menu.quote.quotes": true,
      "sidebar.menu.quote.quote.requests": true,
      // inspection round
      "sidebar.menu.inspection": true,
      "sidebar.menu.inspection.checkpoints": true,
      "sidebar.menu.inspection.round_forms": true,
      "sidebar.menu.inspection.rounds": true,

      "feature.enterprise": false,
      "feature.dashboards.realtime_incidents": false,
      "feature.dashboards.incidents": false,
      "feature.user.delete": false,
      "feature.user.forgot_password": false,
    },
  },
};

export default sourcesConfig;
